import CallIcon from "@mui/icons-material/Call";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import { Button, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

import { UserContext } from "../../../Context/UserContext";

const UserAccountMenu: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const handleClose = (callback: () => void) => () => {
    callback();
    setAnchorEl(null);
  };
  return (
    <>
      <Button color="secondary" onClick={e => user.isAdmin && setAnchorEl(e.currentTarget)}>
        {user.firstName}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        {window.location.pathname === "/" && (
          <MenuItem onClick={handleClose(() => navigate("/admin"))}>
            <ListItemIcon>
              <SupervisorAccountIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Admin Tools" />
          </MenuItem>
        )}
        {window.location.pathname.includes("/admin") && (
          <MenuItem onClick={handleClose(() => navigate("/"))}>
            <ListItemIcon>
              <CallIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Call Waiting" />
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default UserAccountMenu;
